import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

const PostItPage = lazyWithRetry(() =>
  import("@/features/post-it/pages/PostItPage").then((m) => ({ default: m.PostItPage })),
);

export const POST_IT_PATH = "/post-it";

const postItRoutes: RouteConfig[] = [
  {
    path: POST_IT_PATH,
    element: <PostItPage />,
    isProtected: true,
    useMainLayout: true,
  },
];

export default postItRoutes;
